/**
 * Shared shell: semantic root + EditViewToggle + integrated config slot + panel body.
 */

import * as React from 'react';
import { EditViewToggle, type EditViewToggleProps } from './EditViewToggle';
import { cn } from '../lib/utils';

export interface CompositeEditShellProps {
    /** Semantic prefix e.g. speaking-edit — builds class names for toggle and config region */
    prefix: string;
    tabs: EditViewToggleProps['tabs'];
    activeTab: string;
    onTabChange: (tabId: string) => void;
    configSlot?: React.ReactNode;
    renderPanel: (tabId: string) => React.ReactNode;
    className?: string;
}

export function CompositeEditShell({
    prefix,
    tabs,
    activeTab,
    onTabChange,
    configSlot,
    renderPanel,
    className,
}: CompositeEditShellProps): React.ReactElement {
    return (
        <div className={cn(`${prefix} flex flex-col h-full min-h-0 gap-4`, className)}>
            <EditViewToggle
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={onTabChange}
                className={`${prefix}-view-toggle`}
                buttonClassPrefix={`${prefix}-view-toggle-button`}
            />
            {activeTab === 'config' && configSlot != null ? (
                <div className={`${prefix}-config flex-1 min-h-0 overflow-y-auto`}>{configSlot}</div>
            ) : (
                <div className={`${prefix}-panel flex-1 min-h-0 flex flex-col overflow-hidden`}>
                    {renderPanel(activeTab)}
                </div>
            )}
        </div>
    );
}
